module.exports = __webpack_public_path__ + "d1800f23564d941dfd48edf1a60eb606.svg";